module.exports = __webpack_public_path__ + "media/images/svg/faq-76841922e9c0d1f283a4ff479fe6eba8.svg";